import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetRecievableSummaryQuery } from "../../../services/Reports";
import {
  getReceivableSummaryRequest,
  getReceivableSummaryFailure,
  getReceivableSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allReceivableSummary,
    isLoading: receivableSummaryLoading,
    isError: receivableSummaryError,
  } = useGetRecievableSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.receivableSummaryPageNo,
    pageSize: state.receivableSummaryPageSize,
    fromDate: new Date(state.receivableSummaryFromDate).toLocaleDateString(),
    toDate: new Date(state.receivableSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (receivableSummaryLoading) {
      dispatch(getReceivableSummaryRequest());
    }
    if (receivableSummaryError) {
      dispatch(getReceivableSummaryFailure(receivableSummaryError));
    }
    if (allReceivableSummary) {
      dispatch(
        getReceivableSummarySuccess({
          data: allReceivableSummary.data.paymentsReceivedSummary[0].data || [],
          totalPages:
            allReceivableSummary.data.paymentsReceivedSummary[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allReceivableSummary,
    profileData,
    state.receivableSummaryFromDate,
    state.receivableSummaryToDate,
    state.receivableSummaryPageNo,
    state.receivableSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
